import React, { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { INVENTORY_IP_NESTED_ROUTE_DETAIL } from '../../../config/route/NestedRoutesConfig';
import NestedRoute from '../../../shared/components/tabs/NestedRoute';
import { FETCH_INVENTORY_DASHBOARD } from '../../../shared/constants/urlEndPoints';
import { fetchHospitalProfile } from '../../../store/actions/hospitalAction';
import { dashBoardRequest } from '../../../store/actions/leftSideBarAction';
import { getMappedRoute } from '../../../utils/routeUtility';
import { GetFirstElement } from '../../../utils/utility';
import { INVENTORY_MESSAGE_CONSTANTS, PACKAGE_TYPE, REQUEST_PAYLOAD_FOR_ROOM } from './../../../shared/constants/commonConstants';

const InPatient = ({ match, location }: any): ReactElement => {
  const dispatch = useDispatch();
  const hospitalProfileData = useSelector(({ hospital: { hospitalProfile } }: any): any => hospitalProfile);

  const nextDefaultPage = getMappedRoute(location?.pathname, INVENTORY_IP_NESTED_ROUTE_DETAIL)
    || GetFirstElement(INVENTORY_IP_NESTED_ROUTE_DETAIL)?.routeName;

  useEffect((): void => {
    if (hospitalProfileData && !GetFirstElement(hospitalProfileData)?.rooms) {
      dispatch(fetchHospitalProfile(REQUEST_PAYLOAD_FOR_ROOM));
    }
    dispatch(dashBoardRequest({
      title: INVENTORY_MESSAGE_CONSTANTS.title.ip,
      url: `${process.env.REACT_APP_INVENTORY_API_BASE_URL}${FETCH_INVENTORY_DASHBOARD}`, type: PACKAGE_TYPE.INPATIENT,
    }));
    // eslint-disable-next-line
  }, []);
  return (
    <div>
      <NestedRoute
        match={match}
        defaultPage={nextDefaultPage}
        nestedNav={INVENTORY_IP_NESTED_ROUTE_DETAIL} />
    </div>
  );
};

export default InPatient;
